export default {
  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
  },

  components: {},

  mounted() {},

  data() {
    return {
      shown: false,
    };
  },

  computed: {},

  methods: {
    toggle() {
      this.shown = !this.shown;
      if (this.shown) {
        this.$emit('show');
      } else {
        this.$emit('hide');
      }
    },
  },

  watch: {},
};
